// extracted by mini-css-extract-plugin
module.exports = {"status":"QueueStatusCell-status-3oRKC TableRowCell-cell-2fbg4"};